import axios from "axios";

async function GetLocations() {
    return await axios.get(process.env.REACT_APP_API_URL + "/locations")
        .catch(function (error) {
            console.log(error.toJSON());
        });
}

async function GetTopics() {
    return await axios.get(process.env.REACT_APP_API_URL + "/Topics")
        .catch(function (error) {
            console.log(error.toJSON());
        });
}

async function GetQuestions(TopicID, LocationAbbr) {    

    return await axios.get(
        process.env.REACT_APP_API_URL +
        "/Questions?TopicId=" +
        TopicID +
        "&LocationAbbr=" +
        LocationAbbr
    ).catch(function (error) {
        console.log(error.toJSON());
    });
}

async function GetFilters(TopicID, LocationAbbr, QuestionID) {

    return await axios.get(
        process.env.REACT_APP_API_URL +
        "/Filters?&TopicId=" +
        TopicID +
        "&LocationAbbr=" +
        LocationAbbr +
        "&QuestionId=" +
        QuestionID
    ).catch(function (error) {
        console.log(error.toJSON());
    });
}
async function GetComparisonReport(location) {

    return await axios.get(process.env.REACT_APP_API_URL + "/ComparisonReportData?&LocationAbbr=" + location
    ).catch(function (error) {
        console.log(error.toJSON());
    });
}
async function GetTable(
    TopicID,
    LocationAbbr,
    QuestionID,
    YearID,
    DataValueTypeID,
    StratificationCategoryId
) {
    LocationAbbr = LocationAbbr === "ALL" ? "" : LocationAbbr;

    return await axios.get(
        process.env.REACT_APP_API_URL +
        "/TableData?TopicId=" +
        TopicID +
        "&LocationAbbr=" + LocationAbbr +
        "&QuestionId=" +
        QuestionID +
        "&YearID=" +
        YearID +
        "&DataValueTypeId=" +
        DataValueTypeID +
        "&StratificationCategoryId=" +
        StratificationCategoryId
    ).catch(function (error) {
        console.log(error.toJSON());
    });


}

export { GetLocations, GetTopics, GetQuestions, GetFilters, GetTable, GetComparisonReport };
